var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:'lineChart' + _vm.id,attrs:{"height":"140px","width":_vm.width,"id":'lineChart' + _vm.id}})}
var staticRenderFns = []

export { render, staticRenderFns }